import React from "react";
import Modal, { ModalProps } from "react-bootstrap/Modal";
import Image from "react-bootstrap/Image";

import "./StreakInfoModal.scss";
import FilledButton from "../../FilledButton/FilledButton";
import ImageInfoIcon from "../../../../images/interface-alert-warning-circle-interface-light-purple.svg";

function StreakInfoModal(props: ModalProps) {
  const { onHide } = props;

  return (
    <Modal
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="streak-info-modal"
      {...props}
    >
      <div className="MobileOnly info-modal-content">
        <Modal.Body className="modal-content">
          <p className="text-center">
            <Image
              src={ImageInfoIcon}
              alt="hourglass"
              height={105}
              width={105}
            />
          </p>
          <h2>Streak</h2>
          <p className="explainer">
            Come back everyday and play a game to earn GEM. Keep it up for 14
            days and win Jackpot!
          </p>
          <FilledButton onClick={onHide} style={{ height: 52 }}>
            Close
          </FilledButton>
        </Modal.Body>
      </div>
    </Modal>
  );
}

export default StreakInfoModal;
